import { render, staticRenderFns } from "./PlotChangePage.vue?vue&type=template&id=cee78d24&"
import script from "./PlotChangePage.vue?vue&type=script&lang=ts&"
export * from "./PlotChangePage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports